
import React, { useMemo } from "react";
import { Tooltip } from "react-tooltip";
import { formatDecimalNumber, formatIntegerNumber } from "./format-utils";
import { DAFState, UnitLabels } from "./types";
import { getPhColour } from "./color-utils";

export type DAFSensorType = "inlet" | "outlet";

export type DAFSensorPanelProps = {
  sensorType: DAFSensorType;
  dafData: DAFState | undefined | null;
    className?: string;
    selected: boolean;
    changeSelection: () => void;
};

export const DAFSensorPanel = ({
  sensorType,
  dafData,
    className,
    selected,
    changeSelection
}: DAFSensorPanelProps) => {
  const isInlet = sensorType === "inlet";
  const title = isInlet ? "Inlet" : "Outlet";

  const isOff = !Boolean(dafData?.flowrate?.value);

  const details = useMemo(() => {
    return {
      ph: isInlet ? dafData?.inletPH : dafData?.outletPH,
      tss: isInlet ? dafData?.inletTSS : dafData?.outletTSS,
      hasAlarm: isInlet
        ? (dafData?.inletTSS?.alarm || dafData?.inletPH?.alarm) ?? false
        : (dafData?.outletTSS?.alarm || dafData?.outletPH?.alarm) ?? false,
    };
  }, [isInlet, dafData]);

  return (
    /*<div
      className={`${className} daf-sensor-panel ${
        details.hasAlarm ? "--has-alarm" : ""
      } ${isOff ? "--off" : ""}`}
      >*/
    <div
        className={`${className} daf-sensor-panel ${isOff ? "--off" : ""}`}
    >
        <h3 className="daf-sensor-panel__title">{title}</h3>
        <dl className="daf-sensor-panel__details">
            <div
                  className={`daf-sensor-panel__details__row ${selected ? '--selected' : ''} ${isInlet ? '--inlet' : '--outlet'} ${details.ph?.alarm ? 'diagonal-strike' : ''}`}
                  onClick={changeSelection}
                  style={details.ph?.alarm ? {
                      backgroundColor: getPhColour(details.ph?.value ? details.ph?.value : 0),
                  } : undefined}
            >
                <dt
                  className={`daf-sensor-panel__details__label ${
                    details.ph?.alarm ? "--alarm" : ""
                    }`}
                    >
                  pH
                </dt>
                <dd
                  className={`daf-sensor-panel__details__value ${
                    details.ph?.alarm ? "--alarm" : "" }`} >
                  {formatDecimalNumber(details.ph?.value)}
                  {details.ph?.alarm && (
                    <span
                      className="pi pi-exclamation-triangle blinkWarning daf-sensor-panel__details__alarm"
                      data-tooltip-content={details.ph.alarmMessage}
                    ></span>
                  )}
                </dd>
              </div>
              {details.tss && <div
                  className={`daf-sensor-panel__details__row ${isInlet ? '--inlet' : '--outlet'} ${details.tss?.alarm ? 'diagonal-strike' : ''}`}
                  onClick={changeSelection}
                  style={details.tss?.alarm ? {
                      backgroundColor: "rgba(102, 51, 0, 0.5)",
                  } : undefined}
              >
              <dt
              className={`daf-sensor-panel__details__label ${
                details.tss?.alarm ? "--alarm" : ""
              }`}
                  >
                      {details.tss?.label || "TSS"}
            </dt>
            <dd
              className={`daf-sensor-panel__details__value ${
                details.tss?.alarm ? "--alarm" : ""
              }`}
            >
                      {<>{formatIntegerNumber(details.tss?.value)} {UnitLabels[details.tss?.unit ?? -1] ?? "mg/L"}</>}
              {details.tss?.alarm && (
                <span
                  className="pi pi-exclamation-triangle blinkWarning daf-sensor-panel__details__alarm"
                  data-tooltip-content={details.tss.alarmMessage}
                ></span>
              )}
                  </dd>
              </div>}
            <Tooltip
              anchorSelect={`.daf-sensor-panel.${
                isInlet ? "--inlet" : "--outlet"
              } .daf-sensor-panel__details__alarm`}
            />
        </dl>
    </div>
  );
};
